var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 16C19.25 14.258 17.58 12.777 15.25 12.227M13.25 16C13.25 13.79 10.564 12 7.25 12C3.936 12 1.25 13.79 1.25 16M13.25 9C14.3109 9 15.3283 8.57857 16.0784 7.82843C16.8286 7.07828 17.25 6.06087 17.25 5C17.25 3.93913 16.8286 2.92172 16.0784 2.17157C15.3283 1.42143 14.3109 1 13.25 1M7.25 9C6.18913 9 5.17172 8.57857 4.42157 7.82843C3.67143 7.07828 3.25 6.06087 3.25 5C3.25 3.93913 3.67143 2.92172 4.42157 2.17157C5.17172 1.42143 6.18913 1 7.25 1C8.31087 1 9.32828 1.42143 10.0784 2.17157C10.8286 2.92172 11.25 3.93913 11.25 5C11.25 6.06087 10.8286 7.07828 10.0784 7.82843C9.32828 8.57857 8.31087 9 7.25 9Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.12a9b61d389ad191aee2afdfaa93240f.svg";
export { ForwardRef as ReactComponent };